import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { companyJobfeedAutoCompleteInput$, companyJobfeedAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const CompanyJobfeedAutoSuggest = renderAutoSuggestWithOptions(
   companyJobfeedAutoCompleteObservable$,
   companyJobfeedAutoCompleteInput$,
);

CompanyJobfeedAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Company...',
};

export default CompanyJobfeedAutoSuggest;
